import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../../public/locales/en/translation.json';
// import jp from '../../public/locales/jp/translation.json';
// import ko from '../../public/locales/ko/translation.json';
// import zhCN from '../../public/locales/zh-CN/translation.json';

export default i18n
    //   .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: true,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        resources: {
            en: {
                translation: en,
            },
            // 'zh-CN': {
            //     translation: zhCN,
            // },
            // jp: {
            //     translation: jp,
            // },
            // ko: {
            //     translation: ko,
            // },
        },
    });
